import { createSelector } from '@reduxjs/toolkit';
import { selectQualityClaimsCategories } from './selectBasicDetailsClaimsData';

const selectAvailableCategories = createSelector(selectQualityClaimsCategories, categories => {
  if (!categories || categories.length === 0) return [];

  return [...categories[0].categories].sort();
});

export default selectAvailableCategories;
